import Btn from 'components/buttons/Btn'
import CollapsibleListGroup from 'components/CollapsibleList/CollapsibleListGroup'
import * as PropTypes from 'prop-types'
import { ButtonGroup, Col, Row } from 'react-bootstrap'
import ListGroup from 'react-bootstrap/ListGroup'
import { useTranslation } from 'react-i18next'
import Invoice from 'state/models/Invoice'
import { useReseller } from 'state/Reseller'
import { FMT } from 'utils'

/**
 * @param invoices {Invoice[]}
 * @param year {number|string}
 * @return {JSX.Element}
 * @constructor
 */
export default function InvoicesGroup({ invoices, year }) {
	const { t }			= useTranslation()
	const reseller	= useReseller()

	return (
		<CollapsibleListGroup header={year} openByDefault>
			{invoices.map(invoice => ( //FIXME what is shown when the list is weirdly empty?
				<ListGroup.Item key={invoice.id}>
					<Row>
						<Col xs="3" md="2" className="font-weight-bold">
							<span className="text-nowrap">{FMT.date(invoice.created_at, { forceDate: true, noTime: true, noYear: true })}</span>
							<small className="d-block d-md-none text-bold-reset text-nowrap">{invoice.paid_status}</small>
						</Col>

						<Col xs="4" md="3" className="text-right text-nowrap">{FMT.money(invoice.total_amount_due)}</Col>

						<Col md="3" className="d-none d-md-block">{invoice.paid_status}</Col>

						<Col className="text-right">
							<ButtonGroup>
								{(reseller.has_payment_processor && invoice.payable) &&
									<Btn swap target="_blank" icon="credit-card" variant="success" href={invoice.url.pay} title={t('Pay Invoice')} />
								}
								<Btn swap icon="file-pdf" variant="light" href={invoice.url.pdf} title={t('Generate PDF')}>PDF</Btn>
							</ButtonGroup>
						</Col>
					</Row>
				</ListGroup.Item>
			))}
		</CollapsibleListGroup>
	)
}

InvoicesGroup.propTypes = {
	invoices: PropTypes.arrayOf(PropTypes.instanceOf(Invoice)).isRequired,
	year    : PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}
